import { useMemo } from "react"

import { Navigate, useLocation, useMatch, useRoutes } from "react-router-dom"

import { APP_CAMPAIGN, MODULE_CAMPAIGNS } from "@l2r-front/l2r-shared-campaign"
import { Sidebar } from "@l2r-front/l2r-ui"

import { CampaignDetailSidebar } from "../../containers/CampaignDetailSidebar"
import { CampaignSidebar } from "../../containers/CampaignSidebar"
import { useCampaignDetailStateContext } from "../../contexts/CampaignDetailContext"

export const SidebarRouter = () => {

    const { viewMode } = useCampaignDetailStateContext()
    const matchCampaignDetail = useMatch(`:slugId/${APP_CAMPAIGN}/${MODULE_CAMPAIGNS}/:campaignId/*`)
    const { search } = useLocation()

    const sidebarRoutes = useMemo(() => ([
        {
            path: `/${MODULE_CAMPAIGNS}`,
            element: <CampaignSidebar />,
        },
        {
            path: `/${MODULE_CAMPAIGNS}/:campaignId`,
            element: <CampaignDetailSidebar />,
        },
        {
            path: "/*",
            element: <Navigate replace to={`./${MODULE_CAMPAIGNS}${search}`} />,

        },
    ]), [search])

    return <Sidebar shadowed={!!matchCampaignDetail && viewMode === "table"}>{useRoutes(sidebarRoutes)}</Sidebar>
}